import { render, staticRenderFns } from "./discountAddPage.vue?vue&type=template&id=9f041488&scoped=true"
import script from "./discountAddPage.vue?vue&type=script&lang=js"
export * from "./discountAddPage.vue?vue&type=script&lang=js"
import style0 from "./discountAddPage.vue?vue&type=style&index=0&id=9f041488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f041488",
  null
  
)

export default component.exports